import React from "react";
import {
    Modal as BootstrapModal,
    ModalHeader,
    ModalTitle,
    ModalBody,
} from "react-bootstrap";
import { nanoid } from "nanoid";
import '../../styles/Modal.css'

const Modal = ({
    children,
    headerText,
    onClose,
    visible,
    size = "lg",         // default to large
    centered = true,      // default to centered
    style,
}) => {
    const id = nanoid();

    return (
        <BootstrapModal
            size={size}
            show={visible}
            onHide={onClose}
            aria-labelledby={id}
            centered={centered}
            style={style}
            dialogClassName="custom-modal"
        >
            <ModalHeader className="modal-header-custom">
                <ModalTitle id={id} style={{ fontSize: "45px", fontWeight: "500", marginBottom: "20px" }}>{headerText}</ModalTitle>
                <button
                    type="button"
                    className="close-button"
                    aria-label="Close"
                    onClick={onClose}
                >
                    <i className="fas fa-times"></i>
                </button>
            </ModalHeader>

            <ModalBody className="modal-body-scrollbar">
                {children}
            </ModalBody>
        </BootstrapModal>
    );
};

export default Modal;

